import Resource from '@/api/resources/Resource'

class UserappConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/userapps`, filterModel, { params })
        return response.data
    }
    async lastProfileImage(userappId) {
        const response = await this.axios.get(`/configuration/userapps/${userappId}/lastProfileImage`, { headers: { 'content-type': 'multipart/form-data' }, responseType: 'blob' })
        return response.data
    }
    async deleteLastProfileImage(userappId) {
        const response = await this.axios.delete(`/configuration/userapps/${userappId}/deleteLastProfileImage`)
        return response.data
    }
    async getUserappById(userappId) {
        const response = await this.axios.get(`/configuration/userapps/${userappId}`)
        return response.data
    }
    async replaceProfileImageForUser(file, userappId) {
        const formData = new FormData()
        formData.append('file', file, file.name)

        const response = await this.axios.put(
            `/configuration/userapps/${userappId}/attachments/replaceProfileImageForUser`,
            formData, { headers: { 'content-type': 'multipart/form-data' } })
        return response.data
    }
    async changePasswordAndUnlock(userappId, newPassword) {
        const response = await this.axios.put(`/configuration/userapps/${userappId}/changePasswordAndUnlock`, newPassword)
        return response.data
    }
    async patchUserappsBatch(userapps) {
        const response = await this.axios.patch(`/configuration/userapps/batch`, userapps)
        return response.data
    }
    async createUserapp(user) {
        const response = await this.axios.post(`/configuration/userapps`, user)
        return response.data
    }
    async deleteUserappsBatch(userappIds) {
        const data = {
            entityIdentifiers: userappIds
        }
        const response = await this.axios.delete(`/configuration/userapps/batch`, { data: data })
        return response.data
    }
}

export default new UserappConfigurationServices()
